export enum BookingGroupType {
  actual = 'actual',
  past = 'past',
  test = 'test',
}
